import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { AutoComplete } from 'rsuite';

/**
 * Renders a search bar for set searches with icon display
 * Uses set.id (UUID) for unique identification to handle duplicate set names
 * @param {object} props Properties containing term, setTerm, and retrieve function
 * @returns React Component
 */

const SET_ICON_SIZE = isMobile ? 32 : 24;
const SET_ITEM_GAP = isMobile ? 12 : 8;
const SET_ITEM_PADDING = isMobile ? 8 : 4;
const SET_NAME_FONT_SIZE = isMobile ? 16 : 14;
const SET_CODE_FONT_SIZE = isMobile ? 14 : 11;
const SET_ITEM_MIN_HEIGHT = isMobile ? 48 : 'auto';
const SetSearchBar = (props) => {
  const [data, setData] = useState([]);
  const [setMap, setSetMap] = useState({});

  const term = props.term;
  const setTerm = props.setTerm;
  const retrieve = props.retrieve;
  const onSelect = props.onSelect;
  const placeholder = props.placeholder;

  useEffect(() => {
    const fetchData = async () => {
      if (term && term.length >= 2 && !term.includes('//')) {
        try {
          const results = await retrieve(term);
          const formatedResults = JSON.parse(results);

          if (Array.isArray(formatedResults)) {
            const setNames = [];
            const mapById = {};

            formatedResults.forEach((result) => {
              if (result.id && result.name) {
                setNames.push(result.name);
                mapById[result.id] = result;
              }
            });

            setData(setNames);
            setSetMap(mapById);
          } else {
            setData([]);
            setSetMap({});
          }
        } catch (e) {
          console.error('Error fetching sets:', e);
          setData([]);
          setSetMap({});
        }
      } else if (!term || term.length < 2) {
        setData([]);
        setSetMap({});
      }
    };

    fetchData();
  }, [term, retrieve]);

  const handleSelect = (value) => {
    const selectedSet = Object.values(setMap).find(set => set.name === value);
    if (selectedSet) {
      onSelect(selectedSet);
    }
  };

  const renderMenuItem = (label, item) => {
    const set = Object.values(setMap).find(s => s.name === item.value);

    if (!set) {
      return <span style={{ fontSize: SET_NAME_FONT_SIZE }}>{label}</span>;
    }

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: SET_ITEM_GAP, padding: `${SET_ITEM_PADDING}px 0`, minHeight: SET_ITEM_MIN_HEIGHT }}>
        {set.icon_svg_uri && (
          <img
            src={set.icon_svg_uri}
            alt={set.code}
            style={{ height: SET_ICON_SIZE, width: SET_ICON_SIZE, borderRadius: 2, flexShrink: 0 }}
          />
        )}
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 500, fontSize: SET_NAME_FONT_SIZE }}>{set.name}</div>
          <div style={{ fontSize: SET_CODE_FONT_SIZE, color: '#999' }}>{set.code}</div>
        </div>
      </div>
    );
  };

  return (
    <AutoComplete
      data={data}
      value={term}
      onChange={setTerm}
      onSelect={handleSelect}
      placeholder={placeholder}
      renderMenuItem={renderMenuItem}
      filterBy={() => true}
      style={{ width: '100%' }}
    />
  );
};

export default SetSearchBar;
